import { EQrPollingStatusType } from './../../models/components/qrPolling';
import { actions } from '../constants/qrPolling';
import * as actionTypes from '../../models/action/qrPolling';
import { Log } from 'ng2-logger';
import { IPagedQuery } from '../../models/components/paginate';
import { IAttendanceDate, IAttendanceUserData, IClassData } from '../../models/components/qrPolling';


export function GetAttendancesList(ClassId: string, Page: number, Query?: string, Take?: number, OrderBy?: string | null, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IAttendanceList {
    return {
        ClassId,
        Page,
        Query,
        Take,
        OrderBy,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_ATTENDANCES_LIST
    };
}

export function SetAttendancesList(results: Array<IAttendanceDate>, filters: IPagedQuery, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetAttendanceList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ATTENDANCES_LIST
    };
}

export function DeleteAttendances(isAll: boolean, selectedAttendanceIds: Array<string>, disAllowedAttendanceIds?: Array<string>, classId?: string, callback?: () => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IDeletedAttendance {
    return {
        isAll,
        selectedAttendanceIds,
        disAllowedAttendanceIds,
        classId,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DELETE_ATTENDANCE
    };
}

export function CreateQrCodeForAttendance(currentClassId: string, ClassIds: string[], CourseId: string, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ICreateQrCodeForAttendance {
    return {
        currentClassId,
        ClassIds,
        CourseId,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CREATE_QR_CODE_ATTENDANCE
    };
}

export function SetQrCodeForAttendance(attendanceId: string, attendanceGuid: string, attendanceExpirationDate: Date, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetQrCodeForAttendance {
    return {
        attendanceId,
        attendanceGuid,
        attendanceExpirationDate,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QR_CODE_ATTENDANCE
    };
}

export function GenerateQrCode(classId: string, sessionId: string, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGenerateQrCode {
    return {
        classId,
        sessionId,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GENERATE_QR_CODE
    };
}

export function SetGenerateQrCode(QrCodeValue?: any, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetGenerateQrCode {
    return {
        QrCodeValue,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_GENERATE_QR_CODE
    };
}

export function GetAttendanceStudentsList(ClassId: string, AttendanceId: string, AttendanceGuid: string, AttendanceExpirationDate: Date, AttendanceStatus: number | null, Filters: actionTypes.IFilters, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IAttendanceStudentsList {
    return {
        ClassId,
        AttendanceId,
        AttendanceGuid,
        AttendanceExpirationDate,
        AttendanceStatus,
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.GET_ATTENDANCE_STUDENTS_LİST
    };
}

export function SetAttendanceStudentsList(results: Array<IAttendanceUserData>, filters: IPagedQuery, attenDanceCounts: actionTypes.IAttendanceCounts, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetAttendanceUserList {
    return {
        results,
        filters,
        attenDanceCounts,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ATTENDANCE_STUDENTS_LİST
    };
}

export function AddStudentToAttendance(UserIds: string[], ClassId: string, AttendanceId: string, AttendanceGuid: string, StudentListType: EQrPollingStatusType | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IAddStudent {
    return {
        UserIds,
        ClassId,
        AttendanceId,
        AttendanceGuid,
        StudentListType,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.ADD_STUDENT_TO_ATTENDANCE
    };
}

export function RemoveStudentToAttendance(UserIds: string[], ClassId: string, AttendanceId: string, AttendanceGuid: string, StudentListType: EQrPollingStatusType | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IAddStudent {
    return {
        UserIds,
        ClassId,
        AttendanceId,
        AttendanceGuid,
        StudentListType,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.REMOVE_STUDENT_TO_ATTENDANCE
    };
}

export function RefreshAttendanceUserList(userIds: string[], studentListType: EQrPollingStatusType | null, processType: string): actionTypes.IRefreshAttendanceUserList {
    return {
        userIds,
        studentListType,
        processType,
        timestamp: Date.now(),
        type: actions.SET_REFRESH_ATTENDANCE
    };
}

export function GetRefreshAttendances(callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_REFRESH_GENERAL_ATTENDANCE_USER
    };
}

export function GetClassess(CourseId: string, callback?: (value: any) => void): actionTypes.IClassess {
    return {
        CourseId,
        callback,
        timestamp: Date.now(),
        type: actions.GET_CLASSESS
    };
}

export function SetClassess(results: Array<IClassData>): actionTypes.ISetClassess {
    return {
        results,
        timestamp: Date.now(),
        type: actions.SET_CLASSESS
    };
}

export function GetActiveAttendance(classId: string, callback?: (value: any) => void): actionTypes.IGetActiveAttendance {
    return {
        classId,
        callback,
        timestamp: Date.now(),
        type: actions.GET_ACTIVE_ATTENDANCE
    };
}

export function EndAttendance(courseId: string, attendanceGuid: string, callback?: (value: any) => void): actionTypes.IEndAttendance {
    return {
        courseId,
        attendanceGuid,
        callback,
        timestamp: Date.now(),
        type: actions.END_ATTENDANCE
    };
}

export function SetRefreshAttendanceByApi(refreshUsers: Array<IAttendanceUserData>, attenDanceCounts: actionTypes.IAttendanceCounts, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetRefreshAttendanceByApi {
    return {
        refreshUsers,
        attenDanceCounts,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_REFRESH_ATTENDANCE_BY_API
    };
}